import Vue from 'vue';
import App from './App';

const app = new Vue({
    render: render => render(App),
});

export default app;

/**
 * @param {string} element
 */
export function renderGlobalFilters(element = '.products-filter-bar > div') {
    const domElement = document.querySelector(element);

    if (!domElement) {
        console.error(`Element ${element} does not exists`);
        return;
    }

    app.$mount(domElement);
}